import IrisGlobalNavigationReducer from './IrisGlobalNavigationReducer';
import StickyTimerReducer from './StickyTimerReducer';
import IrisHambergurReducer from './IrisHambergurReducer';
import LocationServiceReducer from './LocationServiceReducer';
import ItemCountReducer from './ItemCountReducer';
import LocationReducer from './LocationReducer';
import SignInSliderReducer from './SignInSliderReducer';
import PasswordResetReducer from './PasswordResetReducer';
import PhoneVerificationReducer from './PhoneVerificationReducer';
import PLCCBannerReducer from './PLCCBannerReducer';
import StoreReducer from './StoreReducer';
import ProductSearchDetailReducer from './ProductSearchDetailReducer';
import AdjustmentReducer from './AdjustmentReducer';
import savedItemResponseReducer from './SavedItemResponseReducer';
import OfferDetailsReducer from './PromotionalBannerReducer';
import SavedItemsReducer from './SavedItemsReducer';
import AccountReducer from './AccountReducer';
import ErrorPageReducer from './ErrorPageReducer';
import AccessTokenProviderReducer from './AccessTokenProviderReducer';
import OverlayReducer from './OverlayReducer';
import RegionReducer from './FetchRegionReducers/FetchRegionReducer';
import ObtainRegionZoneReducer from './FetchRegionReducers/ObtainRegionZoneReducer';
import ShowPreviewZoneReducer from './ShowPreviewZoneReducer';
import IrisBannerShopZoneReducer from './IrisBannerShopZoneReducer';
import LazyReducer from '../lazy/reducers/LazyReducer';
import ContextReducer from './ContextReducer';
import TaxonomyReducer from './TaxonomyReducer';
import UrgencyMessagingReducer from './UrgencyMessagingReducer';
import AppointmentReducer from './AppointmentReducer';
import IrisOfferDetailsReducer from './IrisPromotionalBannerReducer';
import optInReducer from './OptInReducer';
import ApplySyfReducer from './ApplySyfReducer';
import ProductSearchFocusReducer from './ProductSearchFocusReducer';
import WeeklyAdsReducer from './WeeklyAdsReducer';
import BgWhiteReducer from './BgWhiteReducer';
import RewardsReducer from './RewardsReducer';
import SliderStatusReducer from './sliderStatusReducer';
import ApiErrorReducer from './ApiErrorReducer';
import IrisGlobalFooterNavigationReducer from './IrisGlobalFooterNavigationLinkReducer';
import FindStoreSliderPropsReducer from './FindStoreSliderPropsReducer';
import FindStoresReducer from './FindStoresReducer';
import HamburgerSliderReducer from './HamburgerSliderReducer';
import RevieveAddToCartReducer from './RevieveAddToCartReducer';
import ATCInterstitialReducer from './ATCInterstitialReducer';
import NativeAppUserDetailsReducer from './NativeAppUserDetailsReducer';
import NativeAppLatLongReducer from './NativeAppLatLongReducer';
import irisReducer from './IrisReducer';
import irisS1TargeterReducer from './IRISS1TargeterReducer';
import ShopTheLookReducer from './ShopTheLookReducer';
import brightEdgeReducer from './BrightEdgeReducer';
import criteoReducer from './CriteoReducer';
import PLCCDynamicBannerReducer from './PlccDynamicBannerReducer';
import ProductOptionsForCongruentPPReducer from './ProductOptionsForCongruentPPReducer';
import RebatesReducer from './RebatesReducer';
import PdpImageZoomReducer from './PdpImageZoomReducer';

const rootReducer = {
    /**
     * IRIS promo banner
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     * IRIS component "textbanner" (home, department, coupon)
     */
    irisPromotionalBannerData: IrisOfferDetailsReducer,
    context: ContextReducer,
    /**
     * get/set user store
     * yoda-microsite-cart/src/components/ItemFulfillmentsNew/ItemFulfillmentsNew.jsx
     * yoda-microsite-cart/src/components/ItemFulfillmentsNew/BopisFulfillmentNew/BopisFulfillmentNew.jsx
     * yoda-microsite-cart/src/components/ItemFulfillmentsNew/ShowDetailedFulfillments/ShowDetailedFulfillments.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-cart/src/containers/Pages/GiftCard/GiftCardBalance.jsx
     * yoda-microsite-checkout/src/containers/Pages/OrderConfirmation/OrderConfirmationPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-gallery/src/components/FilterPanelV2/components/BOPISFacet/components/SelectedStoreDetails/SelectedStoreDetailsV2.jsx
     * yoda-microsite-gallery/src/components/StoresQuickInfo/StoresQuickInfo.jsx
     * yoda-microsite-pdp/src/components/AddToCart/withAddToCartHOC.jsx
     * yoda-site-components/src/components/IrisHamburger/Hamburger.jsx - HeaderFooter
     * yoda-site-components/src/components/IrisHamburger/SelectaStore.jsx - HeaderFooter
     * yoda-site-components/src/components/YodaHeader/SecondaryNavigationPanel.jsx - HeaderFooter
     * yoda-microsite-homepage/src/containers/Pages/FindaStore/FindaStore.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/Common/Common.jsx
     * yoda-microsite-listing/src/containers/Pages/Lists/ListDetailsPanel/ListDetailsPanel.jsx
     * yoda-microsite-coupon/src/helper/MiniPDPHelper.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/PDP.jsx
     * yoda-microsite-marketing/src/helper/renderMiniPDP.jsx
     * yoda-microsite-gallery/src/containers/Pages/Gallery/GalleryDesktop.jsx
     * yoda-microsite-pdp/src/components/StickyHeader/StickyHeader.jsx
     * yoda-site-components/src/components/YodaHeader/SecondaryNavigationPanel.jsx
     */
    selectedStore: StoreReducer,
    /**
     * product search
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     * yoda-microsite-gallery/src/components/NoSearchResults/NoSearchResults.jsx
     */
    productSearchDetailResult: ProductSearchDetailReducer,
    /**
     * get/update coupon application state
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewCheckoutPage/NewCheckoutPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-checkout/src/containers/Pages/Review/ReviewPage.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/LazyModules/CartPageModalsLazy.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/YodaFooter/YodaFooter.jsx
     */
    couponApplicationState: AdjustmentReducer,
    /**
     * get saved items
     * yoda-microsite-gallery/src/AmpComponents/AMPGalleryProductCard/AMPGalleryProductCard.jsx
     * yoda-microsite-gallery/src/components/GalleryProductCard/GalleryProductCard.jsx
     */
    savedItemStatus: savedItemResponseReducer,
    /**
     * promo banner
     * yoda-site-components/src/components/YodaHeader/Header.jsx - header only
     * IRIS component "textbanner" (home, department, coupon)
     */
    promotionalBannerData: OfferDetailsReducer,
    /**
     * saved items
     * yoda-microsite-pdp/src/components/AddToList/AddToList.jsx
     * yoda-microsite-gallery/src/AmpComponents/AMPGalleryProductCard/AMPGalleryProductCard.jsx
     * yoda-microsite-gallery/src/components/GalleryProductCard/GalleryProductCard.jsx
     */
    savedItems: SavedItemsReducer,
    /**
     * accounts
     * yoda-microsite-account/src/containers/Pages/CAMDashboard/CAMDashboardConnect.jsx
     * yoda-microsite-account/src/containers/Pages/CAMDashboard/Components/HomeWrapper.jsx
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPageConnect.jsx
     * yoda-microsite-pdp/src/components/AddToList/AddToList.jsx
     * yoda-microsite-post-purchase/src/containers/Pages/CurbSidePickUp/CSPLanding/CSPLandingConnect.jsx
     * yoda-microsite-post-purchase/src/containers/Pages/Orders/OrdersConnect.jsx
     * yoda-microsite-rewards/src/containers/Pages/ApplySyf/ApplySyfConnect.jsx
     * yoda-microsite-rewards/src/containers/Pages/Rewards/components/RewardsRedesign/Rewards.jsx
     * yoda-microsite-rewards/src/containers/Pages/Rewards/components/RewardsLegacy/RewardsLegacy.jsx
     * yoda-microsite-post-purchase/src/containers/Pages/Orders/Orders.jsx
     * yoda-microsite-listing/src/containers/Pages/TrendingList/TrendingList.jsx
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPage.jsx
     * yoda-microsite-account/src/containers/Pages/CAMDashboard/CAMDashboard.jsx
     * yoda-site-components/src/components/YodaFooter/YodaFooter.jsx
     */
    accounts: AccountReducer,
    /**
     * error page
     * yoda-app-shell/src/server.jsx
     * yoda-app-shell/src/client.jsx
     */
    ErrorPage: ErrorPageReducer,
    /**
     * token info
     * yoda-app-shell/src/server.jsx
     */
    tokenInfo: AccessTokenProviderReducer,
    /**
     * Regional pricing
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     * yoda-microsite-gallery/src/components/NoSearchResults/NoSearchResults.jsx
     */
    regionalPricing: RegionReducer,
    /**
     * show overlay
     * every page
     */
    showOverlay: OverlayReducer,
    /**
     * region zone
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     */
    regionZonefromLocation: ObtainRegionZoneReducer,
    /**
     * preview date time picker
     */
    showPreviewZone: ShowPreviewZoneReducer,
    /**
     * iris banner shop zone
     * yoda-site-components/src/components/IrisHamburger/Hamburger.jsx - HeaderFooter
     * yoda-site-components/src/components/IrisHamburger/SelectaStore.jsx - HeaderFooter
     * yoda-site-components/src/components/YodaHeader/SecondaryNavigationPanel.jsx - HeaderFooter
     * yoda-microsite-homepage/src/containers/Pages/FindaStore/FindaStore.jsx - /findastore page
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     */
    irisBannerShopZoneInfo: IrisBannerShopZoneReducer,
    /**
     * sign in slider details
     * every page
     */
    signInSliderDetails: SignInSliderReducer,
    /**
     * password reset details
     * yoda-microsite-account/src/App.jsx
     * yoda-site-components/src/externalize/Common/Components.js
     */
    passwordResetDetails: PasswordResetReducer,
    productDetailsSliderStatus: SliderStatusReducer,
    /**
     * appointment details
     * yoda-microsite-account/src/containers/Pages/CAMDashboard/CAMDashboardConnect.jsx
     * yoda-microsite-account/src/containers/Pages/CAMDashboard/Components/AppointmentWrapper.jsx
     * yoda-microsite-account/src/containers/Pages/CAMDashboard/Components/HomeWrapper.jsx
     * yoda-microsite-account/src/components/Appointments/Appointments.jsx
     * yoda-microsite-marketing/src/containers/Pages/Barbery/Barbery.jsx
     * yoda-microsite-marketing/src/containers/Pages/Meevo/Meevo.jsx
     * yoda-site-components/src/components/IrisHamburger/Hamburger.jsx - HeaderFooter
     * yoda-site-components/src/components/IrisHamburger/SelectaStore.jsx - HeaderFooter
     * yoda-site-components/src/components/YodaHeader/SecondaryNavigationPanel.jsx - HeaderFooter
     * yoda-microsite-homepage/src/containers/Pages/FindaStore/FindaStore.jsx - /findastore page
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     */
    appointmentDetails: AppointmentReducer,
    /**
     * lazy reducer
     * yoda-microsite-pdp/src/components/AddToList/AddToList.jsx
     * yoda-microsite-pdp/src/selectors/selectLazy.js
     * yoda-microsite-listing/src/containers/Pages/Lists/ListDetailsPanel/ListDetailsPanel.jsx
     * yoda-microsite-coupon/src/helper/MiniPDPHelper.jsx
     * yoda-microsite-pdp/src/containers/Pages/PDP/PDP.jsx
     * yoda-microsite-marketing/src/helper/renderMiniPDP.jsx
     * yoda-microsite-gallery/src/containers/Pages/Gallery/GalleryDesktop.jsx
     * yoda-site-components/src/components/YodaFooter/YodaFooter.jsx
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     * yoda-microsite-gallery/src/components/NoSearchResults/NoSearchResults.jsx
     */
    lazy: LazyReducer,
    /**
     * taxonomy data
     * IRIS component "hotdeals"  (home, department, coupon)
     * IRIS component "recommendations"  (home, department, coupon)
     */
    taxonomyData: TaxonomyReducer,
    /**
     * urgency message
     */
    urgencyMessages: UrgencyMessagingReducer,
    /**
     * phone verification
     * yoda-site-components/src/externalize/Common/Components.js
     * yoda-microsite-account/src/containers/Pages/CAMDashboard/CAMDashboardConnect.jsx
     * yoda-microsite-account/src/containers/Pages/CAMDashboard/Components/MyDetailsWrapper.jsx
     * yoda-microsite-account/src/components/ProfileSettings/MyDetails/MyDetails.jsx
     * yoda-microsite-account/src/App.jsx
     * yoda-microsite-cart/src/containers/Pages/SignIn/components/CreateAccountButton/CreateAccountButton.jsx
     */
    phoneVerification: PhoneVerificationReducer,
    /**
     * plcc banner
     * yoda-microsite-rewards/src/containers/Pages/Rewards/components/RewardsRedesign/Rewards.jsx
     * yoda-microsite-rewards/src/containers/Pages/Rewards/components/RewardsLegacy/RewardsLegacy.jsx
     * yoda-microsite-post-purchase/src/containers/Pages/Orders/Orders.jsx
     * yoda-microsite-listing/src/containers/Pages/TrendingList/TrendingList.jsx
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPage.jsx
     * yoda-microsite-account/src/containers/Pages/CAMDashboard/CAMDashboard.jsx
     * yoda-site-components/src/externalize/Common/Components.js
     */
    plccBannerDetails: PLCCBannerReducer,
    /**
     * optin
     * footer
     */
    optin: optInReducer,
    /**
     * applySyf
     * yoda-microsite-rewards/src/containers/Pages/Rewards/components/RewardsRedesign/Rewards.jsx
     * yoda-microsite-rewards/src/containers/Pages/Rewards/components/RewardsLegacy/RewardsLegacy.jsx
     * yoda-microsite-post-purchase/src/containers/Pages/Orders/Orders.jsx
     * yoda-microsite-listing/src/containers/Pages/TrendingList/TrendingList.jsx
     * yoda-microsite-listing/src/containers/Pages/Lists/ListLandingPage.jsx
     * yoda-microsite-account/src/containers/Pages/CAMDashboard/CAMDashboard.jsx
     * yoda-microsite-account/src/components/BarcodeEdit/subComponents/NoCardItem.jsx
     * yoda-microsite-rewards/src/containers/Pages/LaunchNLearn/LaunchNLearn.jsx
     * yoda-microsite-rewards/src/containers/Pages/ApplySyf/ApplySyfConnect.jsx
     * yoda-microsite-rewards/src/sagas/MicrositeSagas.js
     * yoda-site-components/src/externalize/Common/Components.js
     */
    applySyf: ApplySyfReducer,
    /**
     * productSearchFocus
     * every page
     */
    productSearchFocus: ProductSearchFocusReducer,
    /**
     * weeklyAdsMessages
     * header
     */
    weeklyAdsMessages: WeeklyAdsReducer,
    /**
     * showBgWhite
     * header
     */
    showBgWhite: BgWhiteReducer,
    /**
     * IrisGlobalNavigation
     * yoda-microsite-gallery/src/AmpComponents/AMPSiteComponents/Hamburger/Hamburger.jsx
     * header
     */
    IrisGlobalNavigation: IrisGlobalNavigationReducer,
    /**
     * sticky timer
     * header
     */
    StickyTimerReducer,
    /**
     * irishambergurMenu
     * header
     */
    irishambergurMenu: IrisHambergurReducer,
    /**
     * location service
     * yoda-microsite-account/src/selectors/walletBarcodeSelector.js
     * yoda-microsite-gallery/src/components/Facet/components/BOPISFacet/BOPISFacet.jsx
     * yoda-microsite-gallery/src/sagas/BOPISSaga.js
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-site-components/src/components/IrisHamburger/Hamburger.jsx - HeaderFooter
     * yoda-site-components/src/components/IrisHamburger/SelectaStore.jsx - HeaderFooter
     * yoda-site-components/src/components/YodaHeader/SecondaryNavigationPanel.jsx - HeaderFooter
     * yoda-microsite-homepage/src/containers/Pages/FindaStore/FindaStore.jsx - /findastore page
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     */
    locationServiceReducer: LocationServiceReducer,
    /* update rewards in header
     * All pages from where user can sign in
     */
    rewardsDetails: RewardsReducer,
    /**
     * bag item count
     * yoda-microsite-pdp/src/components/ProductCollection/ProductCollection.jsx
     * Coupon page IRIS component "couponlist"
     * yoda-site-components/src/components/YodaFooter/YodaFooter.jsx
     * yoda-site-components/src/components/YodaHeader/Header.jsx
     */
    bagItemCount: ItemCountReducer,
    /**
     * cookie akZip
     * yoda-site-components/src/components/IrisHamburger/Hamburger.jsx - HeaderFooter
     * yoda-site-components/src/components/IrisHamburger/SelectaStore.jsx - HeaderFooter
     * yoda-site-components/src/components/YodaHeader/SecondaryNavigationPanel.jsx - HeaderFooter
     * yoda-microsite-homepage/src/containers/Pages/FindaStore/FindaStore.jsx - /findastore page
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-gallery/src/sagas/GallerySaga.js
     */
    akZipcode: LocationReducer,
    /**
     * yoda-site-components/src/components/PromotionalBanner/PromotionalBanner.jsx
     */
    apiErrors: ApiErrorReducer,
    /**
     * yoda-site-components/src/components/YodaFooter/YodaFooter.jsx
     */
    IrisFooterGlobalNavigation: IrisGlobalFooterNavigationReducer,

    /**
     * yoda-site-components/lib/components/Layout/Layout.jsx
     */
    findAStoreSliderProps: FindStoreSliderPropsReducer,
    /**
     * find stores
     * yoda-microsite-cart/src/components/ItemFulfillmentsNew/ShipToHomeOrBopisOption/ShipToHomeOrBopisOption.jsx
     * yoda-microsite-cart/src/components/ItemFulfillmentsNew/ShowDetailedFulfillments/ShowDetailedFulfillments.jsx
     * yoda-microsite-checkout/src/sagas/ShipToStoreSaga.js - in microsite
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/GeneralInformation/GeneralInformation.jsx
     * yoda-microsite-checkout/src/containers/Pages/NewShippingPage/ShipToStoreContainer/ChangeStoreOptions/ChangeStoreOptions.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-microsite-pdp/src/components/AddToCart/AddToCart.jsx
     * yoda-microsite-cart/src/containers/Pages/Cart/CartPageWrapper/CartPageWrapper.jsx
     * yoda-microsite-pdp/src/components/DeliveryOption/DeliveryOption.jsx
     * yoda-site-components/lib/components/YodaHeader/Header.jsx
     * yoda-site-components/lib/components/IrisHamburger/Hamburger.jsx
     */
    findStoresDetails: FindStoresReducer,
    HamburgerSlider: HamburgerSliderReducer,
    revieveAddToCart: RevieveAddToCartReducer,
    isAddEditSlider: ATCInterstitialReducer,
    /* yoda-microsite-pdp/src/containers/Pages/PDP/PDP.jsx */
    nativeAppUserDetails: NativeAppUserDetailsReducer,
    /* yoda-site-components/lib/components/LocationFinder/LocationFinder.jsx */
    nativeAppLatLongLocation: NativeAppLatLongReducer,
    /* yoda-site-components/lib/sagas/CMPageSaga.js */
    irisData: irisReducer,
    irisS1Targter: irisS1TargeterReducer,
    shopTheLook: ShopTheLookReducer,
    brightEdgeData: brightEdgeReducer,
    criteo: criteoReducer,
    plccDynamicBanner: PLCCDynamicBannerReducer,
    congruentSelected: ProductOptionsForCongruentPPReducer,
    rebatesInfo: RebatesReducer,
    PdpImageZoomed: PdpImageZoomReducer,
};

export default rootReducer;
